<app-nav></app-nav>
<div id="wrap-router">
  <router-outlet></router-outlet>
</div>
<!--<app-get-started *ngIf="isLoggedOut$ | async"></app-get-started>-->
<app-footer></app-footer>
